export const content = `## On mobile

1. When you login to your account, use the ![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXeXIJwP04KvM06u6WIx8nuaAoPCWQryeyiMM-hYrdALADSohtrLj-88TxvoJlIbRn-v70pQgmMDfThQOPkDhjpr1o65hbeCDqBdZ7ENVcmsAbBJ-fVkdg5ZuMhHnMtnn2AX5ehMmQ?key=X_qAGGjtHqUyfCz1NzAHxOO7) icon to open your navigation menu.
2. Select [**Account Settings**](/settings).
3. Scroll down to **Contact Information**.
4. Where you see your Home Address, select the > icon.
5. Make edits to your address then select **Save**.

## On desktop

1. When you login to your account, go to [**Account Settings**](/settings) from your sidebar navigation.
2. Scroll down to **Contact Information**.
3. Where you see your Home Address, select **Edit**.
4. Make edits to your address then select **Save**.
`;
